import { useParams } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../navigation/paths';
import { CorrectIcon, ExamsIcon, ListIcon, NotifyIcon, ProgressIcon } from '../svgs/SideBarIcon';
import classNames from './bottomTabBar.module.scss';
import BottomTabBarItem from './bottomTabBarItem/BottomTabBarItem';
import useConversation from '../../hooks/queries/useConversation';
import { ShoppingCart } from 'lucide-react';

type BottomTabBarProps = {
  hidden?: boolean;
};

export default function BottomTabBar({ hidden = false }: BottomTabBarProps) {
  const { childId } = useParams<{ childId: string }>();
  const { data: conversation } = useConversation();

  const unSeenMessagesCount: number = conversation?.pages[0].unSeenMessagesCount || 0;
  const notifIcon = (
    <div className="relative">
      <NotifyIcon />
      {unSeenMessagesCount && unSeenMessagesCount > 0 ? (
        <div className="text-center text-[10px] flex items-center justify-center top-0 -translate-y-1/2 translate-x-1/2 bg-red-500 rounded-full font-bold w-4 aspect-square text-light absolute">
          {unSeenMessagesCount}
        </div>
      ) : null}
    </div>
  );

  return (
    <div className={classNames.container} data-hidden={hidden || undefined}>
      <BottomTabBarItem
        title={'التقدم'}
        icon={<ProgressIcon />}
        forward={PROTECTED_PATHS.childProgress.replace(':childId', String(childId))}
      />
      <BottomTabBarItem
        title={'إصلاح التمارين'}
        icon={<CorrectIcon />}
        forward={PROTECTED_PATHS.EXERCISES_CORRECTION.build(Number(childId))}
      />
      <BottomTabBarItem
        title={'الامتحانات'}
        icon={<ExamsIcon />}
        forward={PROTECTED_PATHS.ListSubjectExams.replace(':childId', String(childId))}
      />
      <BottomTabBarItem
        title={'الدعم'}
        icon={notifIcon}
        forward={PROTECTED_PATHS.chatSupport.replace(':childId', String(childId))}
      />
      <BottomTabBarItem
        title={'المتجر'}
        icon={<ShoppingCart size={22} />}
        forward={PROTECTED_PATHS.store.replace(':childId', String(childId))}
      />
      <BottomTabBarItem
        title={'أطفالي'}
        icon={<ListIcon />}
        forward={PROTECTED_PATHS.children}
      />
    </div>
  );
}
